import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of, tap } from 'rxjs';
import { B2bUnitConnector } from '@b2b/features/b2b-unit/core/b2b-unit.connector';
import { B2BUnitService } from '@b2b/features/b2b-unit/core/b2b-unit.service';
import { getB2BUnit, getB2BUnitFail, getB2BUnitSuccess } from '@b2b/features/b2b-unit/core/store/b2b-unit.actions';
import { getCartFail } from '@b2b/features/cart/core/store/cart.actions';
import { getCommerceStorageContext, getCommerceStorageKeys } from '@shared/tools/storage-keys';

@Injectable()
export class B2bUnitEffects {
  selectB2bUnitInFirstLogin$ = createEffect(
    () =>
      this.actions.pipe(
        ofType(getCartFail),
        tap(() => {
          const storageContext = getCommerceStorageContext();
          const b2bUnitId = localStorage.getItem(getCommerceStorageKeys(storageContext).unitId);
          const isAsmContext = storageContext === 'asm';

          if (!b2bUnitId && !isAsmContext) {
            this.b2bUnitService.showSelectionModal();
          }
        }),
      ),
    { dispatch: false },
  );

  getB2bUnitDetails$ = createEffect(() => {
    return this.actions.pipe(
      ofType(getB2BUnit),
      mergeMap(({ b2bUnitId }) => {
        return this.b2bUnitConnector.getB2bUnitDetails(b2bUnitId).pipe(
          map(response => {
            if (response.hasError) {
              return getB2BUnitFail({ message: response.message || '' });
            }
            return getB2BUnitSuccess({ b2bUnit: response });
          }),
          catchError(error => {
            return of(getB2BUnitFail({ message: error?.message || 'Error fetching B2B Unit details' }));
          }),
        );
      }),
    );
  });

  cacheCurrentB2bUnit$ = createEffect(
    () =>
      this.actions.pipe(
        ofType(getB2BUnitSuccess),
        tap(({ b2bUnit }) => {
          const unit = b2bUnit.data;
          const unitDetailsKey = getCommerceStorageKeys().unitDetails;
          if (!unit) {
            localStorage.removeItem(unitDetailsKey);
            return;
          }

          localStorage.setItem(unitDetailsKey, JSON.stringify(unit));
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions: Actions,
    private b2bUnitService: B2BUnitService,
    private b2bUnitConnector: B2bUnitConnector,
  ) {}
}
